import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiShield, FiMail, FiPhone } = FiIcons;

const Urgency = () => {
  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="flex justify-center mb-8">
            <div className="bg-accent-magenta/20 p-6 rounded-full">
              <SafeIcon icon={FiClock} className="w-12 h-12 text-accent-magenta" />
            </div>
          </div>
          
          <h2 className="text-3xl lg:text-5xl font-playfair font-bold mb-8">
            Your Brain Can't Wait Another Sleepless Night
          </h2>
          
          <div className="space-y-6 text-lg leading-relaxed font-raleway mb-12 max-w-3xl mx-auto">
            <p>
              Every sleepless night is another day of foggy thinking, poor decisions, and running on fumes.
            </p>
            <p>
              Sleep deprivation disrupts memory, impairs cognitive performance, and alters task-associated cerebral blood flow<sup className="text-accent-magenta">*</sup>— meaning you're literally forgetting how to think clearly.
            </p>
            <p className="text-accent-gold font-semibold">
              The good news? Your brain is incredibly adaptable. The right executive function training can restore your natural sleep-wake cycle and supercharge your focus.
            </p>
            <p>
              Stop settling for "good enough" sleep. Stop leaning on quick fixes that don't fix anything.
            </p>
            <p className="text-xl font-semibold">
              Your sharpest, most rested self is waiting.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 mb-12">
            <div className="flex justify-center mb-6">
              <SafeIcon icon={FiShield} className="w-10 h-10 text-accent-gold" />
            </div>
            <p className="text-lg font-raleway">
              We're so confident you'll transform your sleep and focus, we offer a <strong>Satisfaction Guarantee</strong>. Do the work, complete the program, and if you don't see the difference, we'll make it right.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <motion.button
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-accent-magenta text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-accent-magenta/90 transition-all duration-200 shadow-xl"
            >
              Book Your Wake-Up Call Today
            </motion.button>
            
            <motion.a
              href="https://www.wethebillions.com/quiz"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-gray-900 transition-all duration-200"
            >
              Take the Free Quiz
            </motion.a>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center text-gray-300">
            <a
              href="mailto:hello@wethebillions.com"
              className="flex items-center gap-2 hover:text-white transition-colors duration-200"
            >
              <SafeIcon icon={FiMail} className="w-5 h-5" />
              hello@wethebillions.com
            </a>
            <a
              href="tel:+12026560054"
              className="flex items-center gap-2 hover:text-white transition-colors duration-200"
            >
              <SafeIcon icon={FiPhone} className="w-5 h-5" />
              (202) 656-0054
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Urgency;